import { numberToMoneyString } from "utils/currency";
import { getCardsValueNumber } from "./cardDetails";
import { CART_CONFIG, VALIDATION_MESSAGES } from "./constants";

export const useCartValidations = () => {
  const { MAX_CART_VALUE, MAX_CART_SIZE } = CART_CONFIG;
  const preValidateCartValue = (value) => {
    const isValid = value <= MAX_CART_VALUE;

    if (!isValid) {
      VALIDATION_MESSAGES.MAX_CART_VALUE(numberToMoneyString(MAX_CART_VALUE));
      // TODO call an error Snackbar with this message
    }

    return isValid;
  };

  const preValidateCartSize = (size) => {
    const isValid = size <= MAX_CART_SIZE;

    if (!isValid) {
      VALIDATION_MESSAGES.MAX_CART_SIZE(MAX_CART_SIZE);
      // TODO call an error Snackbar with this message
    }

    return isValid;
  };

  const preValidateCart = ({ addedCards, cartCards }) => {
    const currentValue = getCardsValueNumber(cartCards);
    const addedValue = getCardsValueNumber(addedCards);

    const validators = [
      () => preValidateCartValue(currentValue + addedValue),
      () => preValidateCartSize(cartCards.length + addedCards.length)
    ];

    const isValid = validators.reduce((isValid, validator) => {
      if (isValid) {
        isValid = validator();
      }
      return isValid;
    }, true);

    return isValid;
  };

  return {
    preValidateCart
  };
};
